import { gql } from "@apollo/client";

export const ADDRESS_PREDICTIONS = gql`
  query addressPredictions($input: String!) {
    addressPredictions(input: $input) {
      predictions {
        placeId
        description
      }
    }
  }
`;

export const ADDRESS_DETAILS = gql`
  query addressDetails($placeId: String!) {
    addressDetails(placeId: $placeId) {
      streetName
      streetNumber
      city
      state
      country
      postalCode
    }
  }
`;

export const BUSINESS_ADDRESS = gql`
  query businessAddress($input: String!) {
    businessAddress(input: $input) {
      address
      city
      state
      zip
    }
  }
`;

export const COUNTRIES = gql`
  query countries {
    countries
  }
`;
